require('../../modules/es6.string.from-code-point');
module.exports = require('../../modules/_core').String.fromCodePoint;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/string/from-code-point.js
// module id = 1473
// module chunks = 0